import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../../environments/environment";
import {InvoiceCreateRequest, InvoiceCreateResponse, InvoiceResponse} from "./model";

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  constructor(
    public http: HttpClient
  ) {
  }

  createInvoice(body: InvoiceCreateRequest, file: File): Observable<InvoiceCreateResponse> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('invoice', JSON.stringify(body));

    return this.http.post<InvoiceCreateResponse>(environment.apiUrl + "/invoices", formData);
  }

  getInvoices(): Observable<InvoiceResponse[]> {
    return this.http.get<InvoiceResponse[]>(environment.apiUrl + "/invoices");
  }

  getInvoiceFile(uuid: string): Observable<Blob> {
    return this.http.get(environment.apiUrl + "/invoices/" + uuid, {
      responseType: 'blob'
    });
  }

}
